import styled from 'styled-components';

import {suffixTestId, TestIdProps} from 'shared/web';

import {getPageNumbers} from '../utils/getPageNumbers';
import {PaginationPage} from './PaginationPage';

interface PaginationPageGroupProps extends TestIdProps {
  activePage: number;
  changePage: (newPage: number) => void;
  isDisabled?: boolean;
  pagesQuantity?: number;
  siblingCount?: number;
  boundaryCount?: number;
  showFirstPage?: boolean;
  showLastPage?: boolean;
  activeIndex?: number;
  isKeyboardNavigation?: boolean;
  getFocusableElements: () => Array<
    {type: 'button'; action: () => void} | {type: 'page'; page: number}
  >;
}

export function PaginationPageGroup(props: PaginationPageGroupProps) {
  const pages = getPageNumbers({
    activePage: props.activePage,
    siblingCount: props.siblingCount,
    boundaryCount: props.boundaryCount,
    pagesQuantity: props.pagesQuantity,
    showFirstPage: props.showFirstPage,
    showLastPage: props.showLastPage,
  });

  const focusableElements = props.getFocusableElements();

  return (
    <StyledWrapper data-testid={props['data-testid']}>
      {pages.map((item, index) => {
        const focusedElement =
          props.activeIndex !== undefined ? focusableElements[props.activeIndex] : undefined;
        const isFocused = focusedElement?.type === 'page' && focusedElement.page === item;

        return (
          <PaginationPage
            key={`pagination_page_${item}_${index}`} // eslint-disable-line react/no-array-index-key -- Pre-existing violation
            page={item}
            activePage={props.activePage}
            changePage={props.changePage}
            isDisabled={props.isDisabled}
            isFocused={isFocused}
            data-testid={suffixTestId(`page-${item}`, props)}
          />
        );
      })}
    </StyledWrapper>
  );
}

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;

  > *:not(style) ~ *:not(style) {
    margin-left: 4px;
  }
`;
